import React from "react";
import * as style from "./styles.module.scss";

const FindJobSection = () => {
  return (
    <div
      id="profileFindJobComponent"
      className={`w-100 bg-white p-1 ${style.profile__findjob}`}
    >
      <h4>Find your next job with HRGO</h4>
      <p className={style.profile__findjob_description}>
        Search for jobs today! We have over 8000 temporary workers earning with
        HRGO each day with more opportunities still available.
      </p>
      <button
        className={`btn btn-primary font-weight-bold  ${style.profile__findjob_button}`}
        onClick={() => {
          const win = window.open("https://hrgo.co.uk/jobs", "_blank");
          win.focus();
        }}
      >
        Find my next job
      </button>
      <img
        className={style.profile__findjob_person}
        src="/images/candidate-area-find-job-customer2.svg"
      />
    </div>
  );
};

export default FindJobSection;
